import { useQuery } from '@tanstack/react-query';
import { get } from '@/lib/api-client';
import type { User } from '@/types';

interface SearchUsersResponse {
  success: boolean;
  data: {
    users: User[];
    total: number;
  };
}

/**
 * Hook to fetch users by role
 */
export function useUsersByRole(role: string) {
  return useQuery({
    queryKey: ['users', 'role', role],
    queryFn: async () => {
      const response = await get<SearchUsersResponse>(`/users/role/${role}`);
      return response.data.users;
    },
    enabled: !!role,
  });
}

/**
 * Hook to search users with filters
 */
export function useSearchUsers(filters: {
  role?: string;
  region?: string;
  market?: string;
  isActive?: boolean;
  search?: string;
}) {
  return useQuery({
    queryKey: ['users', 'search', filters],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (filters.role) params.append('role', filters.role);
      if (filters.region) params.append('region', filters.region);
      if (filters.market) params.append('market', filters.market);
      if (filters.isActive !== undefined) params.append('isActive', String(filters.isActive));
      if (filters.search) params.append('search', filters.search);

      const response = await get<SearchUsersResponse>(`/users/search?${params.toString()}`);
      return response.data.users;
    },
  });
}
